import React from 'react';

import {useRemoveFromFolder} from 'app/documents/api';
import {KBTreeDeleteItemModal} from 'app/kbs/components/KBEditPage/KBTree/KBTreeDeleteItemModal';
import {gt} from 'app/utils/i18n';

import type {ActionableDocumentType} from 'app/general/types';
import type {DocumentSerializedType} from 'sweet-types';

interface Props {
  document: ActionableDocumentType;
  onClose: () => void;
  onSuccess: () => Promise<any>;
}

export function RemoveFromFolderModal({document, onClose, onSuccess}: Props) {
  const [removeFromFolder] = useRemoveFromFolder();

  if (
    document.content_type !== 'document' ||
    document.document_content_type === 'quiz'
  ) {
    return null;
  }

  return (
    <KBTreeDeleteItemModal<DocumentSerializedType>
      toDelete={{
        object: document,
        title: gt('Remove from folder'),
        icon: 'far fa-folder-minus',
        description: gt('Remove %s from this folder?', document.name),
        action: (document) =>
          removeFromFolder({
            id: document.id,
            name: document.name,
            // @ts-expect-error there is no chance that document_content_type can be
            // a quiz, as we exclude it earlier
            document_content_type: document.document_content_type,
            documentURL: document.url,
          }),
        callback: onSuccess,
      }}
      onClose={onClose}
    />
  );
}
